import { injectable, injectFromBase } from 'inversify'
import { DomainSettings } from '@/decorators/domainDecorators'
import DomainBaseService from '@/services/domain/domainBaseService'
import UserPersonalInfo from '@/data/models/domain/UserPersonalInfo'
import type UserPersonalInfoRepository from '@/data/repositories/domain/users/userPersonalInfoRepository'

@DomainSettings({
  model: UserPersonalInfo,
})
@injectable()
@injectFromBase()
export default class UserPersonalInfoService extends DomainBaseService<UserPersonalInfoRepository> {}
